import React from 'react'

export default function UndefinedUser({alt_name}) {
  return (
    <img src="https://viniciusvinna.netlify.app/assets/api-instagram/profiles/profile-placeholder.png" alt={alt_name}/>
  )
}
